import React from 'react'
import Table from '../../components/table'

const CandidateTimesheet = (props: any) => {
  return (
    <section className="tableStyle">
      <Table type='settingscandiatetimesheet' data={props.data} total={props.total} pageSize={props.pageChange} setSort={props.setSort} applySort={props.applySort} sendReminder={props.sendReminder} showHistory={props.showHistory}/>
    </section>
  )
}

export default CandidateTimesheet